/* Locally Twisted — shared scroll fade-in.
   Ported from the memorial-balloons motion.js reveal pattern:
   an IntersectionObserver adds `is-visible` to `.lt-reveal` elements as they
   enter the viewport; CSS then transitions opacity + translateY.

   Progressive enhancement + accessibility:
   - The hidden start state is scoped in CSS to `.lt-fade-ready .lt-reveal`.
     This script adds `lt-fade-ready` to <html> ONLY when motion is allowed,
     so with JS off (or reduced-motion on) content is fully visible and never
     stuck hidden.
   - Respects `prefers-reduced-motion: reduce`.
   - Falls back to revealing everything if IntersectionObserver is missing.
   The paired CSS lives in snippets/lt-fade.liquid.

   THE TWO RULES THIS FILE EXISTS TO ENFORCE
   1. The hidden start state must never outlive the reveal path. The inline
      snippet hides `.lt-reveal` before this file has even been fetched, so a
      404, a blocked asset or a throw in here would strand the Contact inquiry
      panel — the customer's only route to request work — at opacity 0 with no
      way to recover but a full reload. So this file marks <html> with
      `lt-fade-armed` the moment it loads (the snippet drops the hidden state
      at DOMContentLoaded if that mark never appears), and disables itself
      after any reveal-side error rather than leaving content hidden.
   2. Re-init on `shopify:section:load`. A theme-editor save replaces a whole
      section with fresh `.lt-reveal` nodes that the existing observer has
      never seen; without this the merchant watches their own form disappear.
      Same pattern as lt-portfolio.js and lt-select.js. */
(function () {
  'use strict';

  // Reaching this line proves the asset loaded and parsed. See rule 1.
  document.documentElement.classList.add('lt-fade-armed');

  // One observer for the whole document, reused across every re-init, so a
  // long theme-editor session cannot accumulate one observer per save.
  var observer = null;
  var disabled = false;

  function reveal(el) {
    el.classList.add('is-visible');
  }

  function getObserver() {
    if (observer) return observer;
    observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          reveal(entry.target);
          observer.unobserve(entry.target);
        }
      });
    }, { rootMargin: '0px 0px -6% 0px', threshold: 0.08 });
    return observer;
  }

  function wire(scope) {
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    // auto-opt-in shared section headings site-wide (homepage fade requirement)
    scope.querySelectorAll('.lt-rule-head, .lt-trust__head, .title-wrapper-with-link .title').forEach(function (el) {
      el.classList.add('lt-reveal');
    });
    // Already-revealed elements are skipped so a re-init never re-observes
    // (or re-hides) content the visitor is currently looking at.
    var els = scope.querySelectorAll('.lt-reveal:not(.is-visible)');
    if (!els.length) return;

    // Reduced motion or no observer support: show immediately, no motion.
    if (reduce || typeof IntersectionObserver === 'undefined') {
      for (var i = 0; i < els.length; i++) reveal(els[i]);
      return;
    }

    // Motion allowed — opt into the hidden start state, then reveal on scroll.
    document.documentElement.classList.add('lt-fade-ready');

    var io = getObserver();
    for (var j = 0; j < els.length; j++) io.observe(els[j]);
  }

  function init(event) {
    if (disabled) return;
    // `shopify:section:load` hands us the reloaded section; scope to it so the
    // editor only re-wires what actually changed.
    var scope = event && event.target && event.target.querySelectorAll ? event.target : document;
    try {
      wire(scope);
    } catch (err) {
      // The reveal path is broken. Visible-but-unanimated beats invisible:
      // drop the hidden start state and stop touching the DOM entirely, so a
      // later section load cannot re-hide what is now on screen.
      disabled = true;
      document.documentElement.classList.remove('lt-fade-ready');
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  document.addEventListener('shopify:section:load', init);
})();
